module.exports = __webpack_public_path__ + "assets/img/success2.eaba5d89.svg";